module.exports = __webpack_public_path__ + "img/waistband buttons quantity.d2a75f30.png";